import { createContext, ReactNode } from "react";



export interface HamburgerMenuContextType {
  openHamburgerMenu: (content: ReactNode) => void;
  closeHamburgerMenu: () => void;
  isHamburgerMenuOpen: boolean;
}

export const HamburgerMenuContext = createContext<HamburgerMenuContextType>({
  openHamburgerMenu: () => { },
  closeHamburgerMenu: () => { },
  isHamburgerMenuOpen: false,
});
